import { QuoteInfo } from "@deliverr/freight-client";
import { minBy } from "lodash";

export const getLowestQuoteRateForQuoteRequest = (quotes: QuoteInfo[]): QuoteInfo | undefined =>
  minBy(quotes, (quote) => quote.totalCost);
